import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50 ${
        scrolled
          ? 'backdrop-blur-md border-b border-background-200/80'
          : 'border-b border-background-200/50'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-16">
          <Link
            to="/"
            className="text-lg md:text-xl font-heading font-bold text-foreground-950 tracking-tight whitespace-nowrap cursor-pointer"
          >
            itaobuy<span className="text-accent-500">.my</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Home
            </Link>
            <a href="#categories" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Categories
            </a>
            <Link to="/article/itaobuyspreadsheet-shopping-guide" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Shopping Guide
            </Link>
            <Link to="/article/itaobuyspreadsheet-complete-guide" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Guide
            </Link>
            <a href="#faq" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              FAQ
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="ml-2 inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-external-link-line text-xs"></i>
              </div>
              itaobuy sheet
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-900 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4 flex flex-col max-h-[70vh] overflow-y-auto">
          <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm font-semibold text-foreground-900 py-2.5 cursor-pointer border-b border-background-100">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-home-4-line text-base text-accent-500"></i>
            </div>
            Home
          </Link>
          <Link to="/article/itaobuyspreadsheet-shopping-guide" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm font-semibold text-foreground-900 py-2.5 cursor-pointer border-b border-background-100">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-guide-line text-base text-accent-500"></i>
            </div>
            Shopping Guide
          </Link>

          <p className="text-[11px] uppercase tracking-wider text-foreground-400 font-medium mt-3 mb-1 px-1">Product Categories</p>
          {categories.slice(0, 7).map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-sm text-foreground-700 py-2 cursor-pointer hover:text-accent-600 transition-colors"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${cat.icon} text-sm text-foreground-500`}></i>
              </div>
              <span>{cat.name}</span>
              <span className="text-[11px] text-foreground-400 ml-auto">{cat.itemCount}</span>
            </a>
          ))}
          {categories.slice(7).map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 text-sm text-foreground-700 py-2 cursor-pointer hover:text-accent-600 transition-colors"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${cat.icon} text-sm text-foreground-500`}></i>
              </div>
              <span>{cat.name}</span>
              <span className="text-[11px] text-foreground-400 ml-auto">{cat.itemCount}</span>
            </a>
          ))}

          <div className="mt-3 pt-3 border-t border-background-200/60">
            <Link to="/article/itaobuyspreadsheet-complete-guide" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm text-foreground-700 py-2 cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-book-open-line text-sm text-foreground-500"></i>
              </div>
              Complete Guide
            </Link>
            <a href="#faq" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm text-foreground-700 py-2 cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-question-line text-sm text-foreground-500"></i>
              </div>
              FAQ
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="mt-2 inline-flex items-center justify-center gap-2 w-full px-5 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-external-link-line text-sm"></i>
              </div>
              itaobuy sheet
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}